import { render, staticRenderFns } from "./Wap_HWSY01_Produce.vue?vue&type=template&id=ba94f2d6&scoped=true&"
import script from "./Wap_HWSY01_Produce.vue?vue&type=script&lang=js&"
export * from "./Wap_HWSY01_Produce.vue?vue&type=script&lang=js&"
import style0 from "./Wap_HWSY01_Produce.vue?vue&type=style&index=0&id=ba94f2d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba94f2d6",
  null
  
)

export default component.exports